import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { getFileNameCommon } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import { MAX_ROWS_LIMIT } from '@intelligence/components/DownloadCommon/DownloadPage/utils';

const getDownloadApiParams = <T extends Record<string, any> = any>(params: T): T => {
  if (!params) return {} as unknown as T;

  const { dateRange = [] } = params || {};
  const [startDate, endDate] = dateRange;

  const apiParams = {
    start_date: startDate || params?.start_date,
    end_date: endDate || params?.end_date,
    markets: ['global'],
    granularity: 'daily',
    metrics: ['game_count'],
    order_by: ['game_id asc', 'date desc'],
    group_by: ['game_id', 'date', 'minigame_type'],
    minigame_types: params.minigame_types || [],
    page: 1,
    page_size: 10000,
    filter: {
      minigame_genre: [],
    },
    use_sse_page: {
      max_size: MAX_ROWS_LIMIT,
    },
  } as any;

  if (params.app_ids && params.app_ids.length > 0) {
    apiParams.app_ids = params.app_ids;
  }

  return apiParams;
};

export default (params: any) => {
  const apiParams = getDownloadApiParams(params);

  return {
    ...commonSetting,
    downloadMode: 'commonConf',
    downloadConfigKey: 'minigameDetailsStoreRank',
    downloadFetchApi: '/api/v1/intelligence_pc/game/genre_profile/metrics',
    downloadApiParams: apiParams,
    isUsingNewMethod: false,
    fetchOnlyOnce: false,
    dataKey: 'list',
    $$fileName: getFileNameCommon(params),
    regionOptions: params?.regionOptions,
  };
};
